module.exports = __webpack_public_path__ + "static/media/ex10.b35dd742.jpg";